<section class="toolbar" aria-label="Search, filter and sort">
  @if (compactSummary(); as summary) {
    <p class="mini" [class]="'mini ' + summary.tone">
      <span class="dot" aria-hidden="true"></span>{{ summary.headline }}
    </p>
  }

  <div class="search">
    <input
      type="search"
      [placeholder]="searchLabel()"
      [attr.aria-label]="searchLabel()"
      autocomplete="off"
      [value]="query()"
      (input)="setQuery($event)"
      (keydown.escape)="clearAll.emit()"
    />
  </div>

  <div class="filters" role="group" aria-label="Filter">
    <button
      type="button"
      class="chip all"
      [attr.aria-pressed]="allPressed()"
      (click)="clearChips.emit()"
    >
      All <span class="count">{{ allCount() }}</span>
    </button>
    @for (chip of chips(); track chip.key) {
      <button
        type="button"
        [class]="'chip ' + chip.tone"
        [attr.aria-pressed]="chip.pressed"
        (click)="toggleChip.emit(chip.key)"
      >
        {{ chip.label }} <span class="count">{{ chip.count }}</span>
      </button>
    }
  </div>

  <div class="toolbar-end">
    @for (select of selects(); track select.id) {
      <label class="select" [class]="'select ' + (select.className ?? '')">
        <span>{{ select.label }}</span>
        <select (change)="onSelect(select.id, $event)">
          @for (option of select.options; track option.value) {
            <option [value]="option.value" [selected]="option.value === select.value">
              {{ option.label }}
            </option>
          }
        </select>
      </label>
    }

    @if (views().length > 0) {
      <div class="views" role="group" aria-label="View">
        @for (option of views(); track option.value) {
          <button
            type="button"
            class="view"
            [attr.aria-pressed]="view() === option.value"
            (click)="viewChange.emit(option.value)"
          >
            {{ option.label }}
          </button>
        }
      </div>
    }

    <p class="showing" role="status">
      Showing {{ shown() }} of {{ total() }}
      @if (hasFilter()) {
        <button type="button" class="link" (click)="clearAll.emit()">Clear filters</button>
      }
    </p>
  </div>
</section>
